<div class="enhancement-dialog scroll-container">
  <ghs-enhancements
    [action]="data.action"
    [actionIndex]="data.actionIndex"
    [enhancementIndex]="data.enhancementIndex"
    [cardId]="data.cardId"
    [character]="data.character"
    [summon]="data.summon"
    (triggerClose)="close()"
  ></ghs-enhancements>
</div>
